// eslint-disable-next-line import/prefer-default-export
export var BROKERBANS_PAY = 'BROKERBANS_PAY';
